// src/utils/exportToExcel.js
// تصدير أي مصفوفة بيانات إلى ملف Excel
// المكتبة المطلوبة: npm install xlsx

import * as XLSX from 'xlsx';

export function exportToExcel(data, fileName = 'تقرير') {
  if (!data || data.length === 0) {
    alert('لا توجد بيانات لتصديرها');
    return;
  }
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'البيانات');
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
}
